import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/**
 * Custom thank-you URL input component
 * Optional field for redirecting users to a custom page after checkout
 */
export const CustomThankYouUrlInput = () => {
    const { t } = useTranslation(['stores', 'common']);
    const {
        control,
        formState: { errors },
    } = useFormContext<{ customThankYouUrl?: string }>();

    return (
        <div className="space-y-2">
            <Label htmlFor="custom-thank-you-url">
                {t('form.customThankYouUrl')}
            </Label>
            <Controller
                name="customThankYouUrl"
                control={control}
                render={({ field }) => (
                    <Input
                        id="custom-thank-you-url"
                        {...field}
                        value={field.value || ''}
                        placeholder={t('form.customThankYouUrlPlaceholder')}
                    />
                )}
            />
            <p className="text-sm text-muted-foreground">
                {t('form.customThankYouUrlDescription')}
            </p>
            {errors.customThankYouUrl && (
                <p className="text-sm text-red-500">{errors.customThankYouUrl.message as string}</p>
            )}
        </div>
    );
};

